/**
 * Program tier ("level") display helpers.
 *
 * Tiers are optional: maritime programmes use OPRC levels 1/2/3, but a one-off
 * safety course or an onboarding programme has none. Anything showing a tier
 * must handle its absence, so the rule lives here instead of being repeated
 * with `|| 1` fallbacks that quietly turn "no tier" into "Level 1".
 */

// Full label for a program's tier, or null when it has none.
// Honours the institution's own wording (level_label) when set.
export function tierLabel(program) {
  if (!program || program.level == null) return null
  return program.level_label || `Level ${program.level}`
}

// Compact form for chips and dense lists ("L2"), or null when untiered.
export function tierShort(program) {
  if (!program || program.level == null) return null
  return program.level_label || `L${program.level}`
}

// Convenience for string interpolation where an empty string is wanted.
export function tierLabelOrEmpty(program) {
  return tierLabel(program) || ''
}
